import { render, staticRenderFns } from "./StatusLabel.vue?vue&type=template&id=de2236e6&scoped=true"
import script from "./StatusLabel.vue?vue&type=script&lang=ts"
export * from "./StatusLabel.vue?vue&type=script&lang=ts"
import style0 from "./StatusLabel.vue?vue&type=style&index=0&id=de2236e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2236e6",
  null
  
)

export default component.exports